import { random, round2Str } from "../helpers/helpers";

const FIFTEEN_MINUTES = 15 * 60 * 1000;

const isToday = (dateStr) => {
    const today = new Date();
    const date = new Date(dateStr);
    return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
    );
};

const getMaxPointsForDay = (startTime) => {
    if (!isToday(startTime)) return 96;

    const now = new Date();
    const minutesPassed = now.getHours() * 60 + now.getMinutes();
    return Math.floor(minutesPassed / 15);
};

export const generateAhuAnalyticsLineDemo = ({
                                                 meter_id,
                                                 start_time,
                                             }) => {
    const baseTime = new Date(start_time);
    const maxPoints = getMaxPointsForDay(start_time);

    let energyBase = 82430.9;

    // Smooth base values
    let avgVolt = random(242, 244);
    let avgCurrent = random(0.03, 0.05);
    let co2 = random(650, 720);

    const data = [];

    for (let i = 0; i < maxPoints; i++) {
        const time = new Date(baseTime.getTime() + i * FIFTEEN_MINUTES);

        // Gentle drift (realistic trend)
        avgVolt += random(-0.2, 0.2);
        avgCurrent += random(-0.005, 0.005);
        co2 += random(-5, 5);
        energyBase += random(0.002, 0.01);

        const voltR = avgVolt + random(-1, 1);
        const voltY = avgVolt + random(-1, 1);
        const voltB = avgVolt + random(-1, 1);

        console.log(`${time.getFullYear()}-${String(
            time.getMonth() + 1
        ).padStart(2, "0")}-${String(time.getDate()).padStart(
            2,
            "0"
        )} ${String(time.getHours()).padStart(2, "0")}:${String(
            time.getMinutes()
        ).padStart(2, "0")}:00`)

        data.push({
            meter_id: Number(meter_id),

            dtime: `${time.getFullYear()}-${String(
                time.getMonth() + 1
            ).padStart(2, "0")}-${String(time.getDate()).padStart(
                2,
                "0"
            )} ${String(time.getHours()).padStart(2, "0")}:${String(
                time.getMinutes()
            ).padStart(2, "0")}:00`,

            avg_volt: round2Str(avgVolt),
            avg_volt_ll: round2Str(avgVolt * 1.73),
            avg_current: round2Str(avgCurrent),
            avg_pf: round2Str(random(0.88, 0.93)),

            current_r: round2Str(avgCurrent + random(-0.01, 0.01)),
            current_y: round2Str(avgCurrent + random(-0.01, 0.01)),
            current_b: round2Str(avgCurrent + random(-0.01, 0.01)),

            volt_r: round2Str(voltR),
            volt_y: round2Str(voltY),
            volt_b: round2Str(voltB),
            volt_ry: round2Str(voltR + voltY),
            volt_yb: round2Str(voltY + voltB),
            volt_rb: round2Str(voltR + voltB),

            frequency: round2Str(random(49.9, 50.1)),
            co2: round2Str(co2),
            tvoc: round2Str(random(25, 35)),
            formaldehyde: round2Str(random(0.1, 0.15)),

            chilled_water_temp_in: round2Str(random(14.5, 15.2)),
            chilled_water_temp_out: round2Str(random(16.5, 17.5)),
            chilled_water_valve_percent: round2Str(random(18, 25)),
            chilled_water_valve_actual_value: round2Str(random(1800, 2300)),

            fresh_air_damper_percent: round2Str(random(25, 35)),
            fresh_air_damper_actual_value: round2Str(random(4200, 4600)),

            return_air_temp: round2Str(random(26.2, 26.8)),
            return_air_humi: round2Str(random(56, 58)),

            total_active_power: round2Str(random(0.008, 0.015)),
            total_active_energy_imported: round2Str(energyBase),
        });
    }

    return data;
};
